import React from "react";

import "./style.css";
import { ContactIcon } from "../../icons/ContactIcon/ContactIcon";
import { Col, Row } from "react-bootstrap";

export const ContactIconText = () => {
  return (
    // <div className="kontaktna-oseba-icon">
    <Row className="g-5">
      <Col xs={2} md={2} lg={2}>
        <ContactIcon />
      </Col>
      <Col className="d-flex align-items-center ps-4">
        <div className="text-wrapper">KONTAKTNA OSEBA</div>
      </Col>
    </Row>
  );
};